import React, { useState, useEffect, useRef } from 'react';
import careersHeroBackground from '../../Assets/Images/Careers/careersbg2.jpg';
import lifeAtGs1 from '../../Assets/Images/LifeAtGS/UVP00009 copy 2.jpg';
import lifeAtGs2 from '../../Assets/Images/LifeAtGS/UVP00030 copy.jpg';
import lifeAtGs3 from '../../Assets/Images/LifeAtGS/UVP00026 copy.jpg';
import lifeAtGs4 from '../../Assets/Images/LifeAtGS/UVP00034 copy.jpg';
import lifeAtGs5 from '../../Assets/Images/LifeAtGS/UVP00025 copy 2.jpg';
// import userAvatar from '../../Assets/Images/Homepage/Herosectionbg.png';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { Link } from 'react-router-dom';
import axios from 'axios';
// import jobPositionsData from '../Careers/jobData';
import innovation from "../../Assets/Images/Careers/innovation.png";
import growth from "../../Assets/Images/Careers/growth.png";
import collaborative from "../../Assets/Images/Careers/collaborative.png";
import realimpact from "../../Assets/Images/Careers/realimpact.png";
import work from "../../Assets/Images/Careers/teamwork.png";
import prespective from "../../Assets/Images/Careers/perspective.png"

import video1 from '../../Assets/Images/vedioTest/Piyush Bahalkar (3).mp4';
import video2 from '../../Assets/Images/vedioTest/Vaishnavi Koban (5).mp4';
import video3 from '../../Assets/Images/vedioTest/Vaishnavi Koban (5).mp4';
import "../../Assets/CSS/Styles.scss";
const Careers = () => {
  //job opening
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get("http://localhost:8000/api/jobs") // Your API
      .then((res) => {
        if (res.data.success) {
          const sortedJobs = [...res.data.data].sort(
            (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
          );
          setJobs(sortedJobs);
        }
      })
      .catch((err) => {
        console.error("Failed to fetch jobs:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const [formData, setFormData] = useState({
    fullName: '',
    mobileNumber: '',
    emailAddress: '',
    message: ''
  });
  const [resumeFile, setResumeFile] = useState(null);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.id]: e.target.value,
    }));
  };

  const handleFileChange = (e) => {
    setResumeFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccess('');
    setError('');

    if (!resumeFile) {
      setError('Please upload your resume.');
      return;
    }

    try {
      const data = new FormData();
      data.append('fullName', formData.fullName);
      data.append('mobileNumber', formData.mobileNumber);
      data.append('emailAddress', formData.emailAddress);
      data.append('message', formData.message);
      data.append('resume', resumeFile);
      await axios.post('http://localhost:8000/api/getintouch', data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      setSuccess('Form submitted successfully!');
      setFormData({
        fullName: '',
        mobileNumber: '',
        emailAddress: '',
        message: ''
      });
      setResumeFile(null);
      document.getElementById('resume').value = null;

    } catch (err) {
      console.error(err);
      setError('Failed to submit the form. Please try again.');
    }
  };

  // --- State for "Life at Global Solutions" Carousel ---
  const lifeAtGsImages = [
    lifeAtGs1,
    lifeAtGs2,
    lifeAtGs3,
    lifeAtGs4,
    lifeAtGs5,
  ];

  const responsiveLifeAtGs = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 3,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 2,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };
  const [zoomedImage, setZoomedImage] = useState(null);

  // --- State for "Employee Testimonials" Carousel ---
  const testimonials = [
    {
      name: 'Piyush Bahalkar',
      position: 'Backend Developer',
      video: video1,
    },
    {
      name: 'Vaishnavi Koban',
      position: 'UI-UX Designer',
      video: video2,
    },
    {
      name: 'Piyush Bahalkar',
      position: 'Backend Developer',
      video: video3,
    },
  ];

  const [testimonialIndex, setTestimonialIndex] = useState(0);
  const filledStars = 5;
  const videoRef = useRef(null);

  const currentTestimonial = testimonials[testimonialIndex];

  // Handle navigation
  const nextTestimonial = () => {
    setTestimonialIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setTestimonialIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  // Play new video automatically on testimonial change
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.load();
      videoRef.current.play().catch((err) => {
        console.log('Autoplay prevented by browser:', err);
      });
    }
  }, [testimonialIndex]);

  // --- Data for "Why Work at Global Solutions?" Section ---
  const whyWorkReasons = [
    {
      logo: innovation,
      title: "Innovative Culture",
      description: "We work on cutting-edge ERP, SaaS, and cloud solutions for institutions nationwide.",
    },
    {
      logo: growth,
      title: "Growth & Learning",
      description: "Mentorship, training, and real project ownership from day one.",
    },
    {
      logo: collaborative,
      title: "Collaborative Team",
      description: "Designers, developers, marketers — all growing together.",
    },
    {
      logo: realimpact,
      title: "Real Impact",
      description: "Help transform education systems across cities and regions.",
    },
    {
      logo: prespective,
      title: "Inclusive Environment",
      description: "We value every voice and welcome diverse perspectives.",
    },
    {
      logo: work,
      title: "Purpose-Driven Work",
      description: "Every project contributes to making education more accessible and efficient.",
    },
  ];




  return (
    <div className="font-sans antialiased text-gray-800 mt60 ">

      {/* Hero Section */}
      <section
        className="relative h-[500px] md:h-[488px] flex items-center justify-center p-2 overflow-hidden py-10 bg-gray-50 text-white"
      >
        <div
          className="absolute inset-0 bg-center bg-cover"
          style={{ backgroundImage: `url(${careersHeroBackground})` }}
        ></div>
        {/* Overlay for darkening the image */}
        <div className="absolute inset-0 bg-black bg-opacity-60 backdrop-blur-[3px] z-10"></div>

        {/* Content */}
        <div className="relative z-20 text-center max-w-2xl mx-auto px-4">
          <p className="text-sm font-medium mb-4 uppercase tracking-wider">
            👋 We're Hiring Amazing Talent
          </p>
          <h1 className="font-heading font-bold-500 text-white text-2xl md:text-4xl lg:text-5xl mb-6 leading-tight">

            Join the Team Building the <span className="font-heading font-bold-500 mt-10 text-[#FBBF24]"> Future of Education Tech </span>
          </h1>
          <p className="font-ui text-white text-md leading-6 mt-6 mb-8 p">
            At Global Solutions, we're redefining how institutions operate through smart, scalable digital solutions.
          </p>
          <a
            href="#open-positions"
            className="block mx-auto mt-8 text-[15px] demo-button font-bold font-ui flex items-center gap-2 w-48 py-2 rounded-lg bg-[#F59E0B]  hover:bg-[#f3b541] justify-center"
          >
            View Open Roles
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
            </svg>
          </a>
        </div>
      </section>

      {/* Why Work at Global Solutions? Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6 max-w-7xl">
          <div className="text-center mb-12">
            <h2 className="font-heading mb-4 text-[25px] font-bold color: #111827">
              Why Work at Global Solutions?
            </h2>
            <p className="text-center text-[15px] mb-2 color: #374151 font-ui">
              Join a team that's passionate about transforming education through technology
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 ">
            {whyWorkReasons.map((reason, index) => (
              <div className="bg-white rounded-xl shadow-md p-6 hover:shadow-lg transition-shadow duration-300 cardborder relative transition-all duration-300 hover:scale-105 hover:shadow-lg">
                {/* Circular Icon - Positioned at top center overlapping the border */}
                <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 ">
                  <div className="flex items-center justify-center w-16 h-16 rounded-full bg-amber-100 border-2 border-white shadow-md ">
                    {/* {reason.logo} */}
                    <img
                      src={reason.logo}
                      alt={reason.title}
                      className="w-8 h-8 object-contain" // Adjust size as needed
                    />
                  </div>
                </div>

                <div className='mt-5'>
                  <h3 className="text-[25px]font-heading font-bold text-[#111827] mb-2">{reason.title}</h3>
                  <p className="text-[15px] mb-2 color: #374151 font-ui">{reason.description}</p>
                </div>
              </div>

            ))}
          </div>
        </div>
      </section>

      {/* Open Positions Section */}
      <section id="open-positions" className="py-16 bg-[#F8F9FA]">
        <div className="container mx-auto px-6 max-w-7xl">
          <div className="text-center mb-12">
            <h2 className="font-heading mb-4 text-[25px] font-bold text-[#111827]">
              Open Positions
            </h2>
            <p className="text-center text-[15px] mb-2 text-[#374151] font-ui">
              Find your next opportunity to make a difference in education
            </p>
          </div>

          {loading ? (
            <p className="text-center text-gray-500">Loading jobs...</p>
          ) : jobs.length === 0 ? (
            <p className="text-center text-gray-500">No jobs available at the moment.</p>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {jobs.map((job) => (
                <Link
                  to={`/careers/${job._id}`} // Pass job ID to detail page
                  key={job._id}
                  className="block bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 hover:scale-105"
                >
                  <div className="inline-block px-3 py-1 rounded-full text-sm font-medium mb-4 bg-orange-100 text-orange-800">
                    {job.department || "General"}
                  </div>
                  <h3 className="text-xl font-bold text-[#111827] mb-2">
                    {job.position}
                  </h3>
                  <div className="flex items-center text-gray-600 text-sm mb-2">
                    <span className="mr-1">📍</span>
                    {job.workMode}
                  </div>
                  <div className="flex items-center text-gray-600 text-sm mb-2">
                    <span className="mr-1">💼</span>
                    {job.workType}
                  </div>
                  <div className="flex items-center text-gray-600 text-sm mb-4">
                    <span className="mr-1">⏳</span>
                    {job.experience}
                  </div>
                  <p className="text-[15px] mb-2 text-[#374151] font-ui">
                    {job.overview.split(" ").slice(0, 20).join(" ") +
                      (job.overview.split(" ").length > 20 ? "..." : "")}
                  </p>

                  <div className="text-blue-800 font-semibold flex items-center gap-1">
                    View Details ➜
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Life at Global Solutions Section (Carousel) */}
      <div className="w-full max-w-4xl mx-auto px-4 lg:px-0 relative">
        {/* Zoomed image overlay */}
        {zoomedImage && (
          <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 transition-all duration-500">
            <div className="relative">
              <img
                src={zoomedImage}
                alt="Zoomed"
                className="max-w-2xl w-[50vw] h-auto object-contain scale-100 transition-transform duration-500 border-x-8 border-white rounded-lg shadow-2xl"
              />
            </div>
          </div>
        )}
        {/* Carousel */}
        <Carousel
          responsive={responsiveLifeAtGs}
          infinite={true}
          autoPlay={true}
          autoPlaySpeed={3500}
          transitionDuration={600}
          containerClass="carousel-container"
          itemClass="px-4"
          arrows={true}
          showDots={false}
          pauseOnHover={true}
          draggable={true}
          swipeable={true}
          keyBoardControl={true}
        >
          {lifeAtGsImages.map((image, index) => (
            <div
              key={index}
              className="h-80 w-[450px] sm:w-[450px] md:w-[430px] overflow-hidden rounded-lg bg-white relative z-0 cursor-pointer border-2 border-[#F59E0B] shadow-xxl"
              onMouseEnter={() => {
                setZoomedImage(image);
                setTimeout(() => {
                  setZoomedImage(null);
                }, 1000); // ⏳ 1 seconds
              }}
            >
              <img
                src={image}
                alt={`Life at Global Solutions ${index + 1}`}
                className="w-full h-full object-cover rounded-lg shadow-lg transition-transform duration-500 ease-in-out hover:scale-105 border-2 border-[#F59E0B]"
              />
            </div>
          ))}

        </Carousel>
      </div>


      {/* Video */}
      <section className="py-16 bg-[#F8F9FA]">
        <div className="container mx-auto px-6 max-w-3xl">
          <div className="relative bg-white p-8 md:p-12 rounded-xl shadow-lg border border-gray-200 text-center">

            {/* Star Rating */}
            <div className="flex justify-center mb-4">
              {[...Array(5)].map((_, i) => (
                <svg
                  key={i}
                  className={`w-6 h-6 transition-colors duration-300 ${i < filledStars ? 'text-yellow-400 fill-current' : 'text-gray-300'
                    }`}
                  viewBox="0 0 24 24"
                >
                  <path d="M12 .587l3.668 7.568 8.332 1.151-6.064 5.828 1.48 8.241L12 18.295l-7.416 3.978 1.48-8.241L0 9.306l8.332-1.151z" />
                </svg>
              ))}
            </div>

            {/* Video */}
            <div className="mb-8 relative z-10">
              <video
                ref={videoRef}
                className="w-full h-auto rounded-lg shadow-md"
                controls
              >
                <source src={currentTestimonial.video} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>

            {/* Name and Position */}
            <p className="font-bold text-[#111827] text-lg">{currentTestimonial.name}</p>
            <p className="text-gray-600 text-sm">{currentTestimonial.position}</p>

            {/* Navigation Arrows */}
            <button
              onClick={prevTestimonial}
              className="absolute top-1/2 left-4 -translate-y-1/2 p-2 rounded-full bg-white shadow-md text-gray-700 hover:bg-gray-200 focus:outline-none"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7"></path>
              </svg>
            </button>
            <button
              onClick={nextTestimonial}
              className="absolute top-1/2 right-4 -translate-y-1/2 p-2 rounded-full bg-white shadow-md text-gray-700 hover:bg-gray-200 focus:outline-none"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
              </svg>
            </button>
          </div>
        </div>
      </section>

      {/* Didn't Find a Role That Fits? Section */}
      <section className="bg-blue-900 text-white py-16">
        <div className="container mx-auto px-6 max-w-5xl">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Left Section: Didn't Find a Role That Fits? */}
            <div>
              <h2 className="text-2xl md:text-3xl font-heading font-bold mb-4">Didn't Find a Role That Fits?</h2>

              <p className=" font-ui text-white text-md mb-6 ">
                We're always looking for curious minds and passionate individuals. Send us your resume and let's explore opportunities together.
              </p>
              <ul className="space-y-3 mb-8 font-ui text-white text-md ">
                <li className="flex items-center gap-2">
                  <svg className="w-5 h-5 text-[#FFA500]" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" d="M10.45 16.35a1 1 0 01-1.4-1.4l-3-3a1 1 0 011.4-1.4l2.3 2.3 4.3-4.3a1 1 0 011.4 1.4l-5 5a1 1 0 01-.7.3zm-.45 6.65a10 10 0 100-20 10 10 0 000 20z" clipRule="evenodd" />
                  </svg>
                  We review every application personally
                </li>
                <li className="flex items-center gap-2">
                  <svg className="w-5 h-5 text-[#FFA500]" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" d="M10.45 16.35a1 1 0 01-1.4-1.4l-3-3a1 1 0 011.4-1.4l2.3 2.3 4.3-4.3a1 1 0 011.4 1.4l-5 5a1 1 0 01-.7.3zm-.45 6.65a10 10 0 100-20 10 10 0 000 20z" clipRule="evenodd" />
                  </svg>
                  Quick response within 48 hours
                </li>
                <li className="flex items-center gap-2">
                  <svg className="w-5 h-5 text-[#FFA500]" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" d="M10.45 16.35a1 1 0 01-1.4-1.4l-3-3a1 1 0 011.4-1.4l2.3 2.3 4.3-4.3a1 1 0 011.4 1.4l-5 5a1 1 0 01-.7.3zm-.45 6.65a10 10 0 100-20 10 10 0 000 20z" clipRule="evenodd" />
                  </svg>
                  Opportunities across all departments
                </li>
              </ul>
              <button className="bg-[#faa913] px-6 py-3 font-bold rounded-lg demo-button hover:bg-[#e69500] text-[17px] font-ui flex items-center gap-2">
                Send Your Resume
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
                </svg>
              </button>
            </div>

            {/* Right Section: Get in Touch Form */}
            <div className="bg-white p-8 rounded-lg text-gray-800">
              <h2 className="font-heading mb-4 text-[25px] font-bold" style={{ color: '#111827' }}>
                Get in Touch
              </h2>

              {success && <p className="text-green-600 mb-4">{success}</p>}
              {error && <p className="text-red-600 mb-4">{error}</p>}

              <form className="space-y-4" onSubmit={handleSubmit}>
                <div>
                  <label htmlFor="fullName" className="block text-[13px] mb-1 font-ui" style={{ color: '#374151' }}>
                    Full Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    id="fullName"
                    placeholder="Your full name"
                    required
                    value={formData.fullName}
                    onChange={handleChange}
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-[#5B42F3] focus:border-[#5B42F3]"
                  />
                </div>

                <div>
                  <label htmlFor="mobileNumber" className="block text-[13px] mb-1 font-ui" style={{ color: '#374151' }}>
                    Mobile Number <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="tel"
                    id="mobileNumber"
                    placeholder="Your mobile number"
                    required
                    value={formData.mobileNumber}
                    onChange={handleChange}
                    pattern="[0-9]{10}"
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-[#5B42F3] focus:border-[#5B42F3]"
                  />
                </div>

                <div>
                  <label htmlFor="emailAddress" className="block text-[13px] mb-1 font-ui" style={{ color: '#374151' }}>
                    Email Address <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="email"
                    id="emailAddress"
                    placeholder="your.email@example.com"
                    required
                    value={formData.emailAddress}
                    onChange={handleChange}
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-[#5B42F3] focus:border-[#5B42F3]"
                  />
                </div>

                <div>
                  <label htmlFor="message" className="block text-[13px] mb-1 font-ui" style={{ color: '#374151' }}>
                    Tell us about yourself?
                  </label>
                  <textarea
                    id="message"
                    rows="4"
                    placeholder="What role interests you? What makes you excited about working with us?"
                    value={formData.message}
                    onChange={handleChange}
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-[#5B42F3] focus:border-[#5B42F3]"
                  ></textarea>
                </div>

                <div>
                  <label htmlFor="resume" className="block text-[13px] mb-1 font-ui" style={{ color: '#374151' }}>
                    Upload Resume <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="file"
                    id="resume"
                    accept=".pdf,.doc,.docx"
                    required
                    onChange={handleFileChange}
                    className="w-full text-sm text-gray-600
              file:mr-4 file:py-2 file:px-4
              file:rounded-md file:border-0
              file:text-sm file:font-semibold
              file:bg-[#faa913] file:text-[#111827]
              hover:file:bg-[#e69500]
              cursor-pointer"
                  />
                </div>

                <button
                  type="submit"
                  className="bg-[#faa913] px-6 py-3 font-bold rounded-lg demo-button hover:bg-[#e69500] text-[17px] font-ui flex items-center gap-2 w-full justify-center"
                >
                  Send Message
                  <svg
                    className="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
                  </svg>
                </button>
              </form>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default Careers;